import { createContext } from 'react';

export const RightSidebarContext = createContext({
  open: false,
  elementId: null,
});
